import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-3.5,-2h0.5v2h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-1.5,-0.5h2v1h-2zM-3.5,0h1v0.5h-1zM-1,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'wallShade',
      d: 'M3.5,-2.5h0.5v0.5h-0.5zM3,-2h1v0.5h-1zM2.5,-1.5h1.5v0.5h-1.5zM0.5,-1h1v0.5h-1zM2,-1h2v0.5h-2zM0.5,-0.5h3.5v0.5h-3.5zM0.5,0h2.5v0.5h-2.5zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'roofB',
      d: 'M0.5,-6.5h1.5v0.5h-1.5zM-2,-6h4.5v1h-4.5zM-1.5,-5h4.5v0.5h-4.5zM-1,-4.5h4.5v0.5h-4.5zM-1,-4h5v0.5h-5zM-0.5,-3.5h4.5v0.5h-4.5zM0,-3h3.5v0.5h-3.5zM0,-2.5h2.5v0.5h-2.5zM0.5,-2h1v0.5h-1z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2.5,-5.5h0.5v0.5h-0.5zM-3,-5h1.5v0.5h-1.5zM-3,-4.5h2v0.5h-2zM-3.5,-4h2.5v0.5h-2.5zM-4,-3.5h3.5v0.5h-3.5zM-4,-3h4v0.5h-4zM-2,-2.5h2v0.5h-2zM-1,-2h1.5v0.5h-1.5zM1,-1.5h1v0.5h-1zM1.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M4,-3.5h0.5v0.5h-0.5zM-4.5,-3h0.5v0.5h-0.5zM3.5,-3h1v0.5h-1zM-4.5,-2.5h2.5v0.5h-2.5zM2.5,-2.5h1v0.5h-1zM-3,-2h0.5v1.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h1v0.5h-1zM-2,-0.5h0.5v0.5h-0.5zM-2.5,0h1v0.5h-1z',
    },
    { paint: 'trunk', d: 'M-2.5,-2h1v1.5h-1zM-2.5,-0.5h0.5v0.5h-0.5z' },
    {
      paint: 'lanternGlow',
      d: 'M2,-2h1v0.5h-1zM-1,-1.5h1v0.5h-1zM2,-1.5h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M-3,-0.5h0.5v0.5h-0.5z' },
  ],
  pixels: 193,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-3.5,-2h0.5v2h-0.5zM-1.5,-1.5h1v1h-1zM0,-1h0.5v0.5h-0.5zM-1.5,-0.5h2v1h-2zM-3.5,0h1v0.5h-1zM-1,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'wallShade',
      d: 'M-0.5,-5.5h1v0.5h-1zM3.5,-2.5h0.5v0.5h-0.5zM2,-2h2v0.5h-2zM1,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1.5v0.5h-1.5zM0.5,-1h1v0.5h-1zM2,-1h2v0.5h-2zM0.5,-0.5h3.5v0.5h-3.5zM0.5,0h2.5v0.5h-2.5zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'water',
      d: 'M0.5,-6.5h1.5v0.5h-1.5zM-2,-6h1.5v0.5h-1.5zM0,-6h2.5v0.5h-2.5zM-2,-5.5h1v0.5h-1zM0.5,-5.5h2v0.5h-2zM-1.5,-5h0.5v0.5h-0.5zM0.5,-5h2.5v0.5h-2.5zM0.5,-4.5h3v0.5h-3zM0.5,-4h3.5v0.5h-3.5zM-0.5,-3.5h4.5v0.5h-4.5zM0,-3h3.5v0.5h-3.5zM0,-2.5h2.5v0.5h-2.5zM0.5,-2h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.22],
        ['water', 0.78],
      ],
      d: 'M-0.5,-6h0.5v0.5h-0.5zM-2.5,-5.5h0.5v0.5h-0.5zM-1,-5.5h0.5v0.5h-0.5zM-3,-5h1.5v0.5h-1.5zM-3,-4.5h2v0.5h-2zM-3.5,-4h3v0.5h-3zM-4,-3.5h3.5v0.5h-3.5zM-4,-3h4v0.5h-4zM-2,-2.5h2v0.5h-2zM3,-2.5h0.5v0.5h-0.5zM-1,-2h1.5v0.5h-1.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['water', 0.76],
      ],
      d: 'M-1,-5h0.5v1h-0.5zM4,-3.5h0.5v0.5h-0.5zM-4.5,-3h0.5v0.5h-0.5zM3.5,-3h1v0.5h-1zM-4.5,-2.5h2.5v0.5h-2.5zM2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM0.5,-1.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-2.5,-2h1v1.5h-1zM-2.5,-0.5h0.5v0.5h-0.5z' },
    { paint: 'lanternGlow', d: 'M-0.5,-1.5h0.5v1h-0.5zM1.5,-1.5h1v0.5h-1zM1.5,-1h0.5v0.5h-0.5z' },
    { paint: 'fence', d: 'M-3,-1.5h0.5v1.5h-0.5zM-2,-0.5h0.5v0.5h-0.5zM-2.5,0h1v0.5h-1z' },
    { paint: 'chimney', d: 'M-0.5,-5h1v1.5h-1zM-3,-2h0.5v0.5h-0.5z' },
  ],
  pixels: 193,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-3.5,-2h0.5v2h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-1.5,-0.5h2v0.5h-2zM-3.5,0h1v0.5h-1zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'wallShade',
      d: 'M3.5,-2.5h0.5v0.5h-0.5zM2.5,-2h1.5v1h-1.5zM0.5,-1h1v0.5h-1zM2,-1h2v0.5h-2zM0.5,-0.5h3.5v0.5h-3.5zM0.5,0h2.5v0.5h-2.5zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'pine',
      d: 'M0.5,-6.5h1.5v0.5h-1.5zM-2,-6h4.5v1h-4.5zM-1.5,-5h4.5v0.5h-4.5zM-1,-4.5h4.5v0.5h-4.5zM-1,-4h5v0.5h-5zM-0.5,-3.5h4.5v0.5h-4.5zM0,-3h3.5v0.5h-3.5zM0,-2.5h2.5v0.5h-2.5zM0.5,-2h1v0.5h-1z',
    },
    {
      paint: [
        ['pine', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2.5,-5.5h0.5v0.5h-0.5zM-3,-5h1.5v0.5h-1.5zM-3,-4.5h2v0.5h-2zM-3.5,-4h2.5v0.5h-2.5zM-4,-3.5h3.5v0.5h-3.5zM-4,-3h4v0.5h-4zM-2.5,-2.5h2.5v0.5h-2.5zM3,-2.5h0.5v0.5h-0.5zM-1,-2h1.5v0.5h-1.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM1,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pine', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M4,-3.5h0.5v0.5h-0.5zM-4.5,-3h0.5v0.5h-0.5zM3.5,-3h1v0.5h-1zM-4.5,-2.5h2v0.5h-2zM2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM0.5,-1.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-2.5,-2h1v1.5h-1zM-2.5,-0.5h0.5v0.5h-0.5z' },
    {
      paint: 'lanternGlow',
      d: 'M2,-2h0.5v0.5h-0.5zM-1,-1.5h1v0.5h-1zM1.5,-1.5h1v0.5h-1zM-0.5,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M-3,-2h0.5v2h-0.5zM-2,-0.5h0.5v0.5h-0.5z' },
    { paint: 'gardenSoil', d: 'M-2.5,1h1.5v0.5h-1.5zM0,1h1v0.5h-1zM-1.5,1.5h2v0.5h-2z' },
    { paint: 'manorGarden', d: 'M-2.5,0h1.5v0.5h-1.5zM-2.5,0.5h3v0.5h-3zM-1,1h1v0.5h-1z' },
  ],
  pixels: 207,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
